<template>
  <v-footer class="grey lighten-3">
    <div class="container" slot="content">
      <div class="row">
        <div class="col l6 s12">
          <h5 class="black-text">ほげ.class サイトマップ</h5>
          <ul>
            <li class="sub-menu-item black-text"><a href="/">{{ $t('menu.top')}}</a></li>
            <li class="sub-menu-item black-text"><a href="/overview">{{ $t('menu.overview')}}</a></li>
            <li class="sub-menu-item black-text"><a href="/members">{{ $t('menu.members')}}</a></li>
            <li class="sub-menu-item black-text"><a href="/contact">{{ $t('menu.contact')}}</a></li>
          </ul>
        </div>
        <div class="col l4 offset-l2 s12">
          <h5 class="black-text">Links</h5>
          <ul>
            <li>
              <a class="black-text" href="https://minecraft.net/ja/">Minecraft</a>
            </li>
            <li>
              <a class="black-text" href="http://forum.minecraftuser.jp/">非公式日本ユーザフォーラム</a>
            </li>
            <li>
              <a class="black-text" href="https://minecraft.jp/">Japan Minecraft Servers</a>
            </li>
          </ul>
        </div>
      </div>
      <p>当サイトで使用しているアイコンの一部は、Flaticon のものを使用しています。Designed by Freepik and distributed by Flaticon</p>
    </div>
    <div class="container black-text" slot="copyright">
      &copy; Copyright 2014-2016 ほげ.class (Hoge.class)
    </div>
  </v-footer>
</template>

<script>
export default {
  name: 'footbar'
}
</script>


// WEBPACK FOOTER //
// Footbar.vue?8e97aba2